import { render } from "./cards.vue?vue&type=template&id=0ad9355c"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"
script.render = render

export default script